<template>
  <div class="sign-in">
    <v-row class="sign-in-wrapper pa-0 ma-0">
      <v-col class="pa-0 sign-in-image-col" cols="12">
        <div class="sign-in-img">
          <div class="sign-in-cover"></div>
        </div>
        <div class="sign-in-form-container">
          <v-img class="logo" src="/logo-big.png" lazy-src="/logo-big.png">
          </v-img>
          <v-fade-transition>
            <SignInFormVue
              v-if="!signInCompleted"
              @onSubmit="signIn"
              @onGoogle="signInGoogle"
              name="Sign In"
              class="pa-4 mt-2"
            ></SignInFormVue>
          </v-fade-transition>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
  
  <script>
import SignInFormVue from "../components/molecules/signIn/SignInForm.vue";
import { AuthAPIInstance } from "../api";
export default {
  name: "SignInTemplate",
  components: {
    SignInFormVue,
  },
  data() {
    return {
      clipped: true,
      drawer: true,
      fixed: true,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire",
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Admin Panel",
    };
  },
  methods: {
    async signIn(credentials) {
      try {
        await this.$store.dispatch("MainStore/logIn", credentials);
      } catch (error) {
        this.$router.push("/sign-in");
      }
    },

    async signInGoogle() {
      try {
        const { url } = await AuthAPIInstance.getGoogleAuthUrl();

        console.log("URL: ", url);
        window.location = url;
      } catch (error) {
        console.log("Error: ", error);
      }
    },
  },
};
</script>
  
  
  
  <style lang="scss" scoped>
.sign-in {
  height: 100%;
  max-height: 100%;
  width: 100%;
  .sign-in-wrapper {
    height: 100%;
    width: 100%;
  }

  .sign-in-image-col {
    // -webkit-animation: spinX 3s infinite;
    overflow: hidden;
    position: relative;
    .sign-in-img {
      position: absolute;

      left: 0;
      bottom: 0;
      // top: -50vh;
      // left: -50vh;
      width: 100%;
      height: 100%;
      background-image: url("/header-1.png");
      background-size: cover;
      .sign-in-cover {
        height: 100%;
        max-height: 100%;
        width: 100%;
        // backdrop-filter: blur(5px);
      }
    }

    @-webkit-keyframes spinX {
      0% {
        -webkit-transform: rotate(0deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes spinX {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.sign-in-form-container {
  // background: linear-gradient(to bottom, #000, transparent);
  position: absolute;
  right: 40px;
  bottom: 40px;
  width: 40%;
  max-width: 450px;
  overflow: hidden;
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
  border-radius: 4px;

  .logo {
    margin: 0 auto;
    -webkit-transition: width 1s ease-in-out;
    -moz-transition: width 1s ease-in-out;
    -o-transition: width 1s ease-in-out;
    transition: width 1s ease-in-out;
    border-radius: 4px;
  }

  @media (max-width: 864px) {
    width: calc(100% - 40px) !important;
    left: 20px;
    bottom: 20px;
  }
}
</style>
  